import { Injectable } from '@angular/core';
import { ExportContext, ExportFileFormat, ExportRange, ExportService } from 'app/layout/export-overlay';
import { buildQuery, page, seed } from '@albatrosdeveloper/ave-utils-npm/lib/utils/query.util';
import { takeUntil } from 'rxjs';
import get from 'lodash-es/get';
import ceil from 'lodash-es/ceil';
import { UnitMeasureService } from '../unit-of-measurement.service';
import UnitMeasurementsAttributes from '@albatrosdeveloper/ave-models-package/lib/schemas/masters/unit-measurements/unit-measurements.entity';
import { LOCALIZED_PROPERTIES, UNIT_OF_MEASUREMENT_EXPORT_ID, UNIT_OF_MEASUREMENT_TITLE } from './unit-of-measurement.constants';

@Injectable()
export class UnitMeasurementExport {
  constructor(
    private exportService: ExportService,
    private unitService: UnitMeasureService,
  ) {}

  private transformItem(item: UnitMeasurementsAttributes) {
    return {
      code: get(item, 'code', '??'),
      name: get(item, 'name', '??'),
      statusId: this.getStatus(get(item, 'statusId', '')),
    };
  }

  private getStatus(value: string | number): string {
    if(!value && value !== 0) {
        return '';
    }
    return value === 1 ? 'Activo' : 'Inactivo';
  }

  export(format: ExportFileFormat, range: ExportRange, totalItems: number, pageSize: number, pageIndex: number) {
    const totalPages = ceil(totalItems / pageSize) + 1;
    this.exportService.task({
      id: UNIT_OF_MEASUREMENT_EXPORT_ID,
      title: UNIT_OF_MEASUREMENT_TITLE,
      format: format,
      iterations: range === ExportRange.AllPages ? totalPages : 1,
      start: (ctx: ExportContext) => {
        ctx.processor.localizeItemProperties(UNIT_OF_MEASUREMENT_TITLE, LOCALIZED_PROPERTIES);
      },
      next: (ctx: ExportContext) => {
        const currentPage = range === ExportRange.AllPages ? ctx.iteration : pageIndex;
        this.unitService.findByFilter(buildQuery(
          seed(this.unitService.currentFilter), page(currentPage, pageSize)
        ), { contextHeader: 'export' }).pipe(takeUntil(ctx.stopped)).subscribe((response) => {
          get(response, 'data.0.data', []).map((item) => {
            ctx.processor.addToSection(UNIT_OF_MEASUREMENT_TITLE, this.transformItem(item));
          });
          ctx.next();
        });
      },
    }).start();
  }

  canStartTask() {
    if (this.exportService.taskIsActive(UNIT_OF_MEASUREMENT_EXPORT_ID)) {
      this.exportService.setVisible(true);
      return false;
    }
    return true;
  }
}
